import { withDependencies } from '@wix/thunderbolt-ioc'
import { CurrentRouteInfoSymbol, ILinkClickHandler } from '@wix/thunderbolt-symbols'
import { ISamePageScroll } from './types'
import { SamePageScrollSymbol } from './symbols'
import { ICurrentRouteInfo } from 'feature-router'

export const samePageScrollClickHandlerFactory = (
	samePageScroll: ISamePageScroll,
	currentRouteInfo: ICurrentRouteInfo
): ILinkClickHandler => ({
	handleClick: (anchor) => {
		const anchorCompId = anchor.getAttribute('data-anchor-comp-id') || ''
		const anchorDataId = anchor.getAttribute('data-anchor') || ''

		const { relativeUrl } = currentRouteInfo.getCurrentRouteInfo()!
		const isCurrentPageNavigation = relativeUrl === anchor.getAttribute('href')
		if (!anchorCompId && !anchorDataId && isCurrentPageNavigation) {
			// Need to scroll to top of the page if anchor href is for current page
			return samePageScroll.scrollToAnchor({ anchorDataId: 'SCROLL_TO_TOP' })
		}

		return samePageScroll.scrollToAnchor({ anchorDataId, anchorCompId })
	},
})

export const SamePageScrollClickHandler = withDependencies(
	[SamePageScrollSymbol, CurrentRouteInfoSymbol],
	samePageScrollClickHandlerFactory
)
